import React, { Component } from "react";
import PropTypes from "prop-types";

import AuthBody from "Components/Common/AuthBody/AuthBody";
import Stepper from "Components/Common/Stepper/Stepper";
import PopupModal from "Components/Common/PopupModal/PopupModal";

import STRINGS from "Constants/Strings";
import * as ROUTES from "Constants/Routes";
import AppConstants from "Constants/AppConstants";

import {
  S_MEMBER_INFO_WELCOME_SHOWN,
  S_QR_KYC,
  S_STAFF_ID,
  S_USER_ID,
} from "Communication/Constants";

import Review from "./Review";

import "./AboutYou.scss";
import {
  countryAndProvinceIsValid,
  isKycReportRequest,
  memberHasExpiredId,
} from "../../Utils/LogicUtilities";
import { getCurrentStepIndexFromTemplateFlowByStep } from "../../Utils/CommonUtilities";

class AboutYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: props.formData,
      showModal: false,
      showWelcome: false,
      error: false,
      description: "",
      showDataError: false,
      showInfoMessage: false,
      sessionQrKycFlag: false,
    };
  }

  componentDidMount() {
    const sessionQrKycFlag = sessionStorage.getItem(S_QR_KYC);
    this.setState({ sessionQrKycFlag });
  }

  componentDidUpdate(prevProps) {
    const {
      returningMember,
      isInEditFlow,
      inSessionJointApplicant,
      applicantData,
      finInfo,
    } = this.props;

    if (
      finInfo?.name &&
      applicantData?.id &&
      !this.state.showDataError &&
      !countryAndProvinceIsValid(applicantData, finInfo) &&
      !sessionStorage.getItem(S_STAFF_ID)
    ) {
      this.setState({
        showDataError: true,
        description: STRINGS.ABOUTYOU.MESSAGE_ERROR_ADDRESS,
      });
    } else if (
      !this.state.showInfoMessage &&
      !inSessionJointApplicant &&
      memberHasExpiredId(applicantData)
    ) {
      this.setState({
        showInfoMessage: true,
        description: STRINGS.ABOUTYOU.MESSAGE_ERROR_ID_EXPIRED,
      });
    } else if (
      returningMember &&
      prevProps.returningMember !== returningMember &&
      !this.state.showInfoMessage &&
      !isInEditFlow &&
      !isKycReportRequest()
    ) {
      this.setState(
        {
          showWelcome: true,
          description: STRINGS.WELCOME_BACK1,
          description2: STRINGS.WELCOME_BACK2,
        },
        () => {
          sessionStorage.setItem(S_MEMBER_INFO_WELCOME_SHOWN, "true");
        }
      );
    }
  }

  handleDataError = () => {
    const { history } = this.props;
    history.push(ROUTES.VAULT_DASHBOARD);
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.ABOUTYOU);
  };

  render() {
    const {
      formData,
      showModal,
      error,
      description,
      description2,
      showWelcome,
      showDataError,
      showInfoMessage,
      sessionQrKycFlag,
    } = this.state;
    const {
      getDataFromServer,
      continuehandler,
      getActiveProduct,
      sessionCompletedProducts,
      finInfo,
      doCreateNewApplicant,
      vaultProductList,
      doUpdateProductToVault,
      doGetProductFromVault,
      history,
      doUpdateVaultProductList,
      processTemplate,
      doSearchMember,
      isQrKyc,
      kycVault,
      applicantData,
    } = this.props;

    const pageHeader = STRINGS.ABOUTYOU.SCREENTITLE;
    let aboutYou;
    if (formData) {
      aboutYou = (
        <Review
          fName={formData.firstName}
          mName={formData.middleName}
          lName={formData.surName}
          dOB={formData.dateOfBirth}
          address={formData.address}
          addressLine2={formData.addressLine2}
          addressLine3={formData.addressLine3}
          city={formData.city}
          province={formData.state}
          postalCode={formData.postalCode}
          documentNumber={formData.documentNumber}
          expirationDate={formData.expirationDate}
          issueDate={formData.issueDate}
          issuerCode={formData.issuerCode}
          addressState={formData.addressState}
          getDataFromServer={getDataFromServer}
          continuehandler={continuehandler}
          getActiveProduct={getActiveProduct}
          sessionCompletedProducts={sessionCompletedProducts}
          vaultProductList={vaultProductList}
          doUpdateProductToVault={doUpdateProductToVault}
          doGetProductFromVault={doGetProductFromVault}
          processTemplate={processTemplate}
          doSearchMember={doSearchMember}
          kycVault={kycVault}
          applicantData={applicantData}
        />
      );
    } else {
      aboutYou = (
        <Review
          getDataFromServer={getDataFromServer}
          continuehandler={continuehandler}
          getActiveProduct={getActiveProduct}
          sessionCompletedProducts={sessionCompletedProducts}
          doCreateNewApplicant={doCreateNewApplicant}
          vaultProductList={vaultProductList}
          doUpdateProductToVault={doUpdateProductToVault}
          doGetProductFromVault={doGetProductFromVault}
          processTemplate={processTemplate}
          doSearchMember={doSearchMember}
        />
      );
    }

    const { steps, activeStepID } = this.props;
    const productProcessTemplate = getActiveProduct(vaultProductList)
      ?.processTemplate;

    const commonRender = (
      <div
        className={
          isQrKyc ? "[ about-you-container-hidden ]" : "[ about-you-container ]"
        }
      >
        {!isQrKyc && (
          <Stepper
            steps={steps?.length > 0 ? steps : productProcessTemplate?.flow}
            active={
              activeStepID > -1
                ? activeStepID
                : getCurrentStepIndexFromTemplateFlowByStep(
                    productProcessTemplate,
                    AppConstants.APPLICATIONSTEP.ABOUTYOU
                  )
            }
            title={pageHeader}
          />
        )}
        {aboutYou}
      </div>
    );

    return (
      <>
        {showModal && (
          <PopupModal
            type={
              error
                ? AppConstants.MODALTYPE.FAILURE
                : AppConstants.MODALTYPE.SUCCESS
            }
            title={error ? description : AppConstants.MODALTYPE.SUCCESS}
            description=""
            toggleModal={this.toggleModal}
            showModal={showModal}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        {showWelcome && (
          <PopupModal
            type={AppConstants.MODALTYPE.WELCOME_BACK}
            description={description}
            description2={description2}
            showModal={showWelcome}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        {showDataError && (
          <PopupModal
            type={AppConstants.MODALTYPE.FAILURE}
            description={description}
            description2={description2}
            showModal={showDataError}
            popupBtnClick={this.handleDataError}
            closeBtnClick={this.handleDataError}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        {showInfoMessage && (
          <PopupModal
            type={AppConstants.MODALTYPE.INFORMATION}
            description={description}
            description2={description2}
            showModal={showInfoMessage}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        <AuthBody
          actionComponent={commonRender}
          securityText={null}
          infoType="welcomeBack"
          memberCreation
          handleBack={this.handleBack}
          showNavigationBar={!isQrKyc}
        />
      </>
    );
  }
}

AboutYou.propTypes = {
  formData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  isInEditFlow: PropTypes.bool,
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  scanDocument: PropTypes.bool.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  vaultProductList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]),
  getActiveProduct: PropTypes.func,
  finInfo: PropTypes.oneOfType([PropTypes.object]),
  returningMember: PropTypes.bool,
  sessionCompletedProducts: PropTypes.oneOfType([PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.object]),
  applicantData: PropTypes.oneOfType([PropTypes.object]),
};

AboutYou.defaultProps = {
  history: {},
  formData: null,
  isInEditFlow: false,
  steps: [],
  activeStepID: -1,
  vaultProductList: [],
  getActiveProduct: () => {},
  finInfo: {},
  returningMember: false,
  applicantData: null,
};

export default AboutYou;
